import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  Dropdown,
  FormControl,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  removeImage,
  resetData,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./customerSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  setOptionsSelect,
  paramsCustomerType,
  paramsCustomerStatus,
  hari,
  showDialog,
  checkEmptyFields,
  paramsMasterAll,
  setOptionsMaster,
  showDeleteDialog,
  formatterLocation,
  formatterStatus,
  formatterType,
  formatDate,
  formatCurrency,
  akhirBulan,
  awalBulan,
  formatTanggal,
  getSettingValue,
  generateUniqueCode,
  formatterVisit,
  formatDateTime,
  setOptionsMaster2,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import Select from "react-select";

import {
  GoogleMap,
  Autocomplete,
  useLoadScript,
  Marker,
} from "@react-google-maps/api";
import {
  headerSortingClasses,
  sortCaret,
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import InputMask from "react-input-mask";
import {
  selectDataSynch,
  selectEndDateDashboard,
  selectStartDateDashboard,
} from "../company/companySlice";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import PreviewModal from "../../utility/PriviewImg";
import SVG from "react-inlinesvg";
import { ImageViewer } from "../../utility/ImageViewer";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { ViewerImageOld } from "../../utility/ViewerImageOld";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";
import { NavLink } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  fetchOrder,
  selectLoadingOrder,
  selectOrder,
} from "../order/orderSlice";
import { InputDateRange } from "../../utility/InputDateRange";
import { useLocation } from "react-router-dom";
import {
  fetchParam,
  fetchParam2,
  fetchParam3,
  selectDataParam,
  selectDataParam2,
  selectDataParam3,
} from "../param/paramSlice";
import { selectSetting } from "../setting/settingSlice";
import { fetchVisit, selectVisit } from "../visit/visitSlice";
import { fetchTop, selectTop } from "../top/topSlice";
import { ModalDatalog } from "../../utility/ModalDatalog";

const libraries = ["places"];
const mapContainerStyle = {
  width: "400px",
  height: "400px",
};

const center = {
  lat: -3.745,
  lng: -38.523,
};

export const CustomerCreate = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const loading2 = useSelector(selectLoadingTemplate);
  const loading3 = useSelector(selectLoadingOrder);
  const dataId = useSelector(selectId);
  const synch = useSelector(selectDataSynch);
  const user = useSelector(selectUser);
  const dataUser = useSelector(selectDataUser);
  const dataOrder = useSelector(selectOrder);
  const dataVisit = useSelector(selectVisit);
  const dataStartDateDashboard = useSelector(selectStartDateDashboard);
  const dataEndDateDashboard = useSelector(selectEndDateDashboard);
  const dataParam = useSelector(selectDataParam);
  const dataParam2 = useSelector(selectDataParam2);
  const dataParam3 = useSelector(selectDataParam3);
  const dataTOP = useSelector(selectTop);
  const dataSetting = useSelector(selectSetting);

  const { id } = useParams();
  const { SearchBar } = Search;

  const MIN_PHOTO_VISIT = getSettingValue(dataSetting, "MIN_PHOTO_CUSTOMER");
  const MAX_PHOTO_VISIT = getSettingValue(dataSetting, "MAX_PHOTO_CUSTOMER");

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [contact, setContact] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [contact2, setContact2] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");
  const [contact3, setContact3] = useState("");
  const [phoneNumber3, setPhoneNumber3] = useState("");
  const [alamat, setAlamat] = useState("");
  const [provinsi, setProvinsi] = useState("");
  const [kota, setKota] = useState("");
  const [kecamatan, setKecamatan] = useState("");
  const [kelurahan, setKelurahan] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [kunjungan, setKunjungan] = useState([]);
  const [outlet, setOutlet] = useState("");
  const [frequensi, setFrequensi] = useState("");
  const [volume, setVolume] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [sellingOut, setSellingOut] = useState("");
  const [NIK, setNIK] = useState("");
  const [NPWP, setNPWP] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showPreviewOld, setShowPreviewOld] = useState(false);
  const [dataPreview, setDataPreview] = useState("");
  const [dataPreviewOld, setDataPreviewOld] = useState(null);
  const [refCode, setRefCode] = useState("");
  const [TOP, setTOP] = useState("7");
  const [sales, setSales] = useState("");
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const [fileNIK, setFileNIK] = useState(null);
  const [fileNPWP, setFileNPWP] = useState(null);
  const [fileFoto1, setFileFoto1] = useState(null);
  const [fileFoto2, setFileFoto2] = useState(null);

  const [show, setShow] = useState(false);
  const [defaultLocation, setDefaultLocation] = useState(null);
  const [optionsFreq, setOptionsFreq] = useState([]);
  const [optionsOutlet, setOptionOutlet] = useState([]);
  const [optionsPaymentType, setOptionPaymentType] = useState([]);
  const [optionsTOP, setOptionTOP] = useState([]);
  const [optionsUser, setOptionsUser] = useState([]);

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);
  const [tableDataOrder, setTableDataOrder] = useState([]);
  const [tableDataVisit, setTableDataVisit] = useState([]);

  const [startOrder, setStartOrder] = useState(formatTanggal(awalBulan));
  const [endOrder, setEndOrder] = useState(formatTanggal(akhirBulan));

  const [startPlan, setStartPlan] = useState(formatTanggal(awalBulan));
  const [endPlan, setEndPlan] = useState(formatTanggal(akhirBulan));

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const additionalParam = queryParams.get("additionalParam");
  const additionalParamStart = queryParams.get("startDate");
  const additionalParamEnd = queryParams.get("endDate");

  // Datalog

  const [showDatalog, setShowDatalog] = useState(false);
  const [showDatalogDetail, setShowDatalogDetail] = useState(false);
  const [fetched, setFetched] = useState(false);

  const [fields, setFields] = useState([
    {
      files: null,
      type: `LOKASI ${generateUniqueCode()}`,
    },
  ]);

  const [activeTab, setActiveTab] = useState("Location");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const ref = useRef();
  const paramsId = {
    customer_id: id,
  };

  if (additionalParam === "OrderHistory") {
    window.scrollTo(0, 850);
  }

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        })
      );

      await dispatch(fetchTop({ ...paramsMasterAll }));

      await dispatch(
        fetchParam({
          ...paramsMasterAll,
          param_group_code: "FREQUEN",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam2({
          ...paramsMasterAll,
          param_group_code: "CUSTOMER_GROUP",
          is_active: true,
        })
      );
      await dispatch(
        fetchParam3({
          ...paramsMasterAll,
          param_group_code: "PAYMENT_TYPE",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch, id]);

  useEffect(() => {
    const allDayWithChecked = () => {
      return allDay.map((day) => {
        const isChecked = hari.includes(day.value.toLowerCase());
        return { ...day, checked: isChecked };
      });
    };

    setKunjungan(allDayWithChecked);
  }, []);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster2(dataUser, setOptionsUser, "user_id", [
        "username",
        "name",
      ]);
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataId) {
      setActiveTab(additionalParam === null ? "Location" : "OrderHistory");

      // additionalParam === "OrderHistory"
      //   ? window.scrollTo(0, 850)
      //   : window.scrollTo(0, 0);
      setCode(dataId.customer_code);
      setName(dataId.customer_store_name);
      setStatus(dataId.customer_store_status);
      setContact(dataId.customer_contact_name);
      setPhoneNumber(dataId.customer_phone_number);
      setContact2(dataId.customer_contact_name2);
      setPhoneNumber2(dataId.customer_phone_number2);
      setContact3(dataId.customer_contact_name3);
      setPhoneNumber3(dataId.customer_phone_number3);
      setShow2(!!dataId.customer_contact_name2);
      setShow3(!!dataId.customer_contact_name3);
      setAlamat(dataId.customer_address);
      setProvinsi(dataId.customer_provinsi);
      setKota(dataId.customer_kab_kota);
      setKecamatan(dataId.customer_kecamatan);
      setKelurahan(dataId.customer_kelurahan);
      setLatitude(dataId.customer_latitude);
      setLongitude(dataId.customer_longitude);
      setNIK(dataId.customer_nik);
      setNPWP(dataId.customer_npwp);
      setFrequensi(dataId.bisparfrequen_id);
      setRefCode(dataId.ref_customer_code);
      setDefaultLocation({
        lat: parseFloat(dataId.customer_latitude),
        lng: parseFloat(dataId.customer_longitude),
      });
      setClickedPosition({
        lat: parseFloat(dataId.customer_latitude),
        lng: parseFloat(dataId.customer_longitude),
      });

      setVolume(dataId.bisparvolume_id);
      setOutlet(dataId.customer_group);
      setCustomerType(dataId.customer_payment_type);
      setTOP(dataId.term_of_payment_in_days);
      setSales(dataId.user_id);

      const allDayWithChecked = () => {
        const hariArray = dataId.bisparhari_kunjungan
          .split(",")
          .map((day) => day.trim());
        return allDay.map((day) => {
          const isChecked = hariArray.includes(day.value);
          return { ...day, checked: isChecked };
        });
      };

      setKunjungan(allDayWithChecked);

      if (additionalParam === "OrderHistory") {
        setStartOrder(additionalParamStart);
        setEndOrder(additionalParamEnd);
        dispatch(
          fetchOrder({
            ...paramsMasterAll,
            customer_id: id,
            start_order_date: additionalParamStart,
            end_order_date: additionalParamEnd,
          })
        );
      } else {
        dispatch(
          fetchOrder({
            ...paramsMasterAll,
            customer_id: id,
            start_order_date: startOrder,
            end_order_date: endOrder,
          })
        );
      }

      dispatch(
        fetchVisit({
          ...paramsMasterAll,
          customer_id: id,
          start_visit_plan_date: startPlan,
          end_visit_plan_date: endPlan,
        })
      );
    }
  }, [dataId]);

  useEffect(() => {
    if (dataOrder.length > 0) {
      const initData = dataOrder.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          sales_name: item.sales_person_code + "-" + item.sales_person_name,
        };
      });

      setTableDataOrder(initData);
    }
  }, [dataOrder]);

  useEffect(() => {
    if (dataVisit.length > 0) {
      console.log("jalan");

      const initData = dataVisit.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });

      setTableDataVisit(initData);
    }
  }, [dataVisit]);

  console.log(dataVisit, "dataVisit");

  const handleChecked = (value) => {
    const newData = kunjungan.map((item) => {
      if (item.value === value) {
        return { ...item, checked: true };
      }
      return item;
    });

    setKunjungan(newData);
  };

  const handleRemoveChecked = (value) => {
    const newData = kunjungan.map((item) => {
      if (item.value === value) {
        return { ...item, checked: false };
      }
      return item;
    });

    setKunjungan(newData);
  };

  useEffect(() => {
    if (dataParam.length > 0) {
      setOptionsMaster(dataParam, setOptionsFreq, "param_code", "param_value");
    }
  }, [dataParam]);
  useEffect(() => {
    if (dataParam2.length > 0) {
      setOptionsMaster(
        dataParam2,
        setOptionOutlet,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam2]);

  useEffect(() => {
    if (dataParam3.length > 0) {
      setOptionsMaster(
        dataParam3,
        setOptionPaymentType,
        "param_code",
        "param_value"
      );
    }
  }, [dataParam3]);

  useEffect(() => {
    if (dataTOP?.length > 0) {
      setOptionsMaster(dataTOP, setOptionTOP, "due_date_days", "top_name");
    }
  }, [dataTOP]);

  const handleChangeCustType = createChangeHandler(setCustomerType);
  const handleChangeTop = createChangeHandler(setTOP);
  const handleChangeVolume = createChangeHandler(setVolume);
  const handleChangeStatus = createChangeHandler(setStatus);

  const handleChangeFrequensi = (e) => {
    if (e === null) {
      e = undefined;
      setFrequensi("");

      const newData = kunjungan.map((item) => {
        return { ...item, checked: false };
      });

      setKunjungan(newData);
    } else {
      setFrequensi(e.value);
    }
  };

  const handleChangeOutlet = (e) => {
    if (e === null) {
      e = undefined;
      setOutlet("");
    } else {
      setOutlet(e.value);
    }
  };

  const handleSave = async () => {
    const filterVisit = kunjungan
      .filter((item) => item.checked)
      .map((item) => item.value);

    const validasi = [
      { value: name, message: "input Nama Toko", valid: true },
      { value: status, message: "input Status Toko", valid: true },
      // { value: NIK, message: "input NIK", valid: true },
      // { value: NPWP, message: "input NPWP", valid: true },
      // {
      //   value: fileFoto1,
      //   message: "upload photo location",
      //   valid:
      //     dataId === null
      //       ? true
      //       : dataId?.customer_tempat_1_file_path === null
      //       ? true
      //       : false,
      // },
      // {
      //   value: fileNIK,
      //   message: "upload photo NIK",
      //   valid:
      //     dataId === null
      //       ? true
      //       : dataId?.customer_nik_file_path === null
      //       ? true
      //       : false,
      // },
      // {
      //   value: fileNPWP,
      //   message: "upload photo NPWP",
      //   valid:
      //     dataId === null
      //       ? true
      //       : dataId?.customer_npwp_file_path === null
      //       ? true
      //       : false,
      // },
      // { value: clickedPosition, message: "chose location", valid: true },
      { value: customerType, message: "select customer type", valid: true },
      { value: outlet, message: "select outlet", valid: true },
      { value: phoneNumber, message: "input phone number", valid: true },
      { value: sales, message: "input Sales", valid: true },
    ];

    const errorMessage = checkEmptyFields(validasi);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    // Validasi wajib isi contact2 dan phoneNumber2 kalau show2 aktif
    if (show2 && (!contact2.trim() || !phoneNumber2.trim())) {
      return showDialog("Contact 2 dan Nomor Telepon 2 required");
    }

    // Validasi wajib isi contact3 dan phoneNumber3 kalau show3 aktif
    if (show3 && (!contact3.trim() || !phoneNumber3.trim())) {
      return showDialog("Contact 3 dan Nomor Telepon 3 required");
    }

    // // Validasi wajib isi contact3 dan phoneNumber3 kalau show3 aktif
    // if (NPWP.length < 15 || NPWP.length > 16) {
    //   return showDialog("NPWP must consist of 15 to 16 digits");
    // }

    const payload = {
      customer_id: id,
      // customer_code: code,
      company_id: user.company_id,
      customer_store_name: name,
      customer_store_status: status,
      customer_contact_name: contact,
      customer_phone_number: phoneNumber,
      customer_contact_name2: contact2,
      customer_phone_number2: phoneNumber2,
      customer_contact_name3: contact3,
      customer_phone_number3: phoneNumber3,
      customer_address: alamat,
      customer_provinsi: provinsi,
      customer_kab_kota: kota,
      customer_kecamatan: kecamatan,
      customer_kelurahan: kelurahan,
      customer_latitude: latitude,
      customer_longitude: longitude,
      customer_nik: NIK,
      customer_npwp: NPWP,
      ref_customer_code: refCode,
      bisparhari_kunjungan: filterVisit.toString(),
      bisparfrequen_id: frequensi,
      customer_group: outlet,
      bisparvolume_id: volume,
      customer_payment_type: customerType,
      term_of_payment_in_days: customerType === "CREDIT" ? parseInt(TOP) : 0,
      user_id: sales,
    };
    const files = {
      fileNIK: fileNIK,
      fileNPWP: fileNPWP,
    };

    const filesLokasi = fields;

    try {
      const response =
        id === undefined
          ? await dispatch(addItem({ payload, files, filesLokasi }))
          : await dispatch(editItem({ payload, files, filesLokasi }));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
        await setFileNIK(null);
        await setFileNPWP(null);
        await setFileFoto1(null);
        await setFileFoto2(null);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  // maps

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_KEY,
    libraries,
  });
  const mapRef = useRef();

  const [autocomplete, setAutocomplete] = useState(null);
  const [userPosition, setUserPosition] = useState(null);
  const [clickedPosition, setClickedPosition] = useState(null);

  const paramsFilterRange = {
    ...paramsMasterAll,
    customer_id: id,
  };

  useEffect(() => {
    getUserPosition();
  }, []);

  const getUserPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userPos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setUserPosition(userPos);
          // Menyesuaikan pusat peta dengan posisi pengguna
          // mapRef.current.panTo(userPos);
        },
        (error) => {
          console.error("Error getting user position:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const onLoad = (autocomplete) => {
    setAutocomplete(autocomplete);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      // ... Bagian ekstraksi alamat dan informasi lokasi lainnya

      // Dapatkan latitude dan longitude
      const latitude = place.geometry.location.lat();
      const longitude = place.geometry.location.lng();

      // Set properti center ke lokasi yang dipilih
      const userPos = {
        lat: latitude,
        lng: longitude,
      };

      mapRef.current.panTo(userPos);

      const addressComponents = place.address_components;

      // Ekstrak alamat, provinsi, kota, kecamatan, dan kelurahan dari hasil geocoding
      const address = place.formatted_address;
      const province =
        addressComponents.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name || "";
      const city =
        addressComponents.find((component) =>
          component.types.includes("administrative_area_level_2")
        )?.long_name || "";
      const district =
        addressComponents.find((component) =>
          component.types.includes("administrative_area_level_3")
        )?.long_name || "";
      const subdistrict =
        addressComponents.find((component) =>
          component.types.includes("administrative_area_level_4")
        )?.long_name || "";
      const village =
        addressComponents.find((component) =>
          component.types.includes("sublocality_level_2")
        )?.long_name || "";

      // Lakukan sesuatu dengan data yang diekstrak
      setLatitude(latitude);
      setLongitude(longitude);
      setAlamat(address);
      setProvinsi(province);
      setKota(city);
      setKecamatan(district);
      setKelurahan(subdistrict);
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };
  const handleClick = (event) => {
    setClickedPosition({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });

    // Buat instance Geocoder
    const geocoder = new window.google.maps.Geocoder();

    // Lakukan geocoding untuk mendapatkan informasi alamat dari koordinat yang diklik
    geocoder.geocode(
      { location: { lat: event.latLng.lat(), lng: event.latLng.lng() } },
      (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            const place = results[0];
            const addressComponents = place.address_components;

            // Ekstrak alamat, provinsi, kota, kecamatan, dan kelurahan dari hasil geocoding
            const address = place.formatted_address;
            const province =
              addressComponents.find((component) =>
                component.types.includes("administrative_area_level_1")
              )?.long_name || "";
            const city =
              addressComponents.find((component) =>
                component.types.includes("administrative_area_level_2")
              )?.long_name || "";
            const district =
              addressComponents.find((component) =>
                component.types.includes("administrative_area_level_3")
              )?.long_name || "";
            const subdistrict =
              addressComponents.find((component) =>
                component.types.includes("administrative_area_level_4")
              )?.long_name || "";
            const village =
              addressComponents.find((component) =>
                component.types.includes("sublocality_level_2")
              )?.long_name || "";

            // Dapatkan latitude dan longitude
            const latitude = event.latLng.lat();
            const longitude = event.latLng.lng();

            // Set nilai latitude dan longitude serta variabel lainnya
            setLatitude(latitude);
            setLongitude(longitude);
            setAlamat(address);
            setProvinsi(province);
            setKota(city);
            setKecamatan(district);
            setKelurahan(subdistrict);
          } else {
            console.error("No results found");
          }
        } else {
          console.error("Geocoder failed due to: " + status);
        }
      }
    );
  };

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading Maps";

  const handlePreview = (data) => {
    setShowPreview(true);

    setDataPreview(data);
  };

  const handlePreviewOld = (data) => {
    setShowPreviewOld(true);
    setDataPreviewOld(data);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
    setShowPreviewOld(false);
    setDataPreview(null);
    setDataPreviewOld(null);
  };

  const handleChangeSales = createChangeHandler(setSales);

  const handleDelete = async (type) => {
    const params = { customer_id: id, file_type: type };

    const action = await showDeleteDialog(`Are you sure want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeImage(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await window.location.reload();
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        console.log(error);
        showErrorDialog("Something went wrong!");
      }
    }
  };

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
        handleCloseUpload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: " code",
      dataField: "customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "name",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "reff code",
      dataField: "ref_customer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "group",
      dataField: "customer_group",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "nik",
      dataField: "customer_nik",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "npwp",
      dataField: "customer_npwp",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "type",
      dataField: "customer_payment_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterType,
    },

    {
      text: "Frequency",
      dataField: "bisparfrequen_id",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "hari kunjungan",
      dataField: "bisparhari_kunjungan",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "contact name",
      dataField: "customer_contact_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "phone number",
      dataField: "customer_phone_number",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "Sales",
      dataField: "username",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "TOP",
      dataField: "term_of_payment_in_days",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const handleDownload = async () => {
    const params = {
      file_type: "CUSTOMER",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "CUSTOMER.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const columnsOrder = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },
    {
      text: "order no",
      dataField: "order_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "200px" },
      formatter: (cell, row) => {
        return (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
            }}
          >
            <NavLink
              className="menu-link"
              to={`/transaction/order/detail/${row.visit_order_id}`}
            >
              {cell}
            </NavLink>
          </span>
        );
      },
    },
    {
      text: "order date",
      dataField: "order_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDate,
    },

    {
      text: "type",
      dataField: "customer_payment_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterType,
    },

    {
      text: "order due date",
      dataField: "order_due_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDate,
    },

    {
      text: "status",
      dataField: "status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "Sales Name",
      dataField: "sales_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "order amount",
      dataField: "order_total",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "return amount",
      dataField: "order_retur",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },

    {
      text: "final amount",
      dataField: "order_final",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },

    {
      text: "sum paid",
      dataField: "order_sum_paid",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "Remaining amount",
      dataField: "order_remain",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
  ];

  const columnsVisit = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "customer ",
      dataField: "customer_store_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: (cell, row) => {
        return (
          <div>
            <span>
              <b>{row.customer_code}</b>
            </span>
            <br />
            <span
              style={{
                cursor: "pointer",
                color: "blue",
              }}
            >
              <NavLink
                className="menu-link"
                to={`/transaction/journey/visit/${row.visit_id}`}
              >
                {row.customer_store_name}
              </NavLink>
            </span>{" "}
          </div>
        );
      },
    },
    {
      text: "category group",
      dataField: "customer_group_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
    },
    {
      text: "payment type",
      dataField: "customer_payment_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "100px" },
      formatter: formatterType,
    },
    {
      text: "visit category",
      dataField: "visit_category",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "status distance",
      dataField: "status_distance",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
      formatter: (cell, row) => {
        return (
          <div>
            <b style={{ marginRight: "8px" }}>
              {formatterStatus(row.status_distance)}
            </b>
            <span className="text-right"> | {row.checkin_distance} M</span>
          </div>
        );
      },
    },

    {
      text: "payment cash",
      dataField: "payment_cash",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "payment transfer",
      dataField: "payment_transfer",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "payment total",
      dataField: "payment_total",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatCurrency,
      align: "right",
    },
    {
      text: "visit status",
      dataField: "visit_status_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterVisit,
    },
    {
      text: "visit date",
      dataField: "visit_actual_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDateTime,
    },
    {
      text: "remarks pending",
      dataField: "remarks_pending",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  // Handle file change
  const handleFileChangeToko = (index, event) => {
    const newFields = [...fields];
    newFields[index].files = event.target.files[0];
    setFields(newFields);
  };

  // Handle delete file
  const handleDeleteFileToko = (index, event, type) => {
    const newFields = [...fields];
    newFields[index].files = null;
    setFields(newFields);
  };

  // Handle add new field
  const handleAddFotoToko = () => {
    setFields([
      ...fields,
      { files: null, type: `LOKASI ${generateUniqueCode()}` },
    ]);
  };

  const handlePhoneChange = (setter, value) => {
    const numericValue = value.replace(/\D/g, "");
    if (numericValue.length <= 13) {
      setter(numericValue);
    }
  };

  const handleShowDatalog = (data) => {
    setShowDatalog(true);
  };

  const handleCloseDatalog = (data) => {
    setShowDatalog(false);
  };

  return loading || loading2 || loading3 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Customer" : "Edit Customer"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id !== undefined && (
              <Button
                className="btn btn-outline-primary mr-3 d-flex align-items-center justify-content-center"
                onClick={() => handleShowDatalog()}
              >
                <i className="fa fa-info-circle"></i> Log
              </Button>
            )}

            {id === undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}
            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                {id !== undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        onChange={(e) => setCode(e.target.value)}
                        value={code}
                        maxLength={20}
                        disabled={id !== undefined ? true : false}
                      />
                    </Col>
                  </Form.Group>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Ref Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setRefCode(e.target.value)}
                      value={refCode}
                      // maxLength={20}
                      // disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Customer Name<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Status Tempat<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={paramsCustomerStatus}
                      value={getValueStatus(status, paramsCustomerStatus)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                    />
                  </Col>
                </Form.Group>

                <div>
                  {/* Contact 1 */}
                  <Form.Group as={Row} className="mb-2">
                    <Form.Label column sm={3}>
                      <b>
                        Name Contact <b className="color-red">*</b>
                      </b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>
                      <b>
                        Nomor Telepon <b className="color-red">*</b>
                      </b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        value={phoneNumber}
                        onChange={(e) =>
                          handlePhoneChange(setPhoneNumber, e.target.value)
                        }
                        maxLength={13}
                      />
                    </Col>
                    <Col sm={3} className="d-flex align-items-center">
                      {!show2 && (
                        <Button
                          variant="success"
                          onClick={() => setShow2(true)}
                        >
                          +
                        </Button>
                      )}
                    </Col>
                  </Form.Group>

                  {/* Contact 2 */}
                  {show2 && (
                    <>
                      <Form.Group as={Row} className="mb-2">
                        <Form.Label column sm={3}>
                          <b>
                            Name Contact 2 <b className="color-red">*</b>
                          </b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            value={contact2}
                            onChange={(e) => setContact2(e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={3}>
                          <b>
                            Nomor Telepon 2 <b className="color-red">*</b>
                          </b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            value={phoneNumber2}
                            onChange={(e) =>
                              handlePhoneChange(setPhoneNumber2, e.target.value)
                            }
                            maxLength={13}
                          />
                        </Col>
                        <Col sm={3} className="d-flex align-items-center">
                          {!show3 && (
                            <Button
                              variant="success"
                              onClick={() => setShow3(true)}
                            >
                              +
                            </Button>
                          )}
                          <Button
                            variant="danger"
                            className="ms-2"
                            onClick={() => {
                              setShow2(false);
                              setContact2("");
                              setPhoneNumber2("");
                              setShow3(false);
                              setContact3("");
                              setPhoneNumber3("");
                            }}
                          >
                            -
                          </Button>
                        </Col>
                      </Form.Group>
                    </>
                  )}

                  {/* Contact 3 */}
                  {show3 && (
                    <>
                      <Form.Group as={Row} className="mb-2">
                        <Form.Label column sm={3}>
                          <b>
                            Name Contact 3 <b className="color-red">*</b>
                          </b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            value={contact3}
                            onChange={(e) => setContact3(e.target.value)}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm={3}>
                          <b>
                            Nomor Telepon 3 <b className="color-red">*</b>
                          </b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            value={phoneNumber3}
                            onChange={(e) =>
                              handlePhoneChange(setPhoneNumber3, e.target.value)
                            }
                            maxLength={13}
                          />
                        </Col>
                        <Col sm={3} className="d-flex align-items-center">
                          <Button
                            variant="danger"
                            onClick={() => {
                              setShow3(false);
                              setShow2(true);
                              setContact3("");
                              setPhoneNumber3("");
                            }}
                          >
                            -
                          </Button>
                        </Col>
                      </Form.Group>
                    </>
                  )}
                </div>
              </Col>
              {/* Right Row */}
              <Col sm={6}>
                {id !== undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Repeat Order</b>
                    </Form.Label>
                    <Col sm={6}>
                      <Form.Control
                        type="text"
                        disabled
                        value={dataId?.repeat_order}
                      />
                    </Col>
                  </Form.Group>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Jenis Outlet <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={optionsOutlet}
                      value={getValueStatus(outlet, optionsOutlet)}
                      placeholder="Select ..."
                      onChange={handleChangeOutlet}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Sales <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={optionsUser}
                      value={getValueStatus(sales, optionsUser)}
                      placeholder="Select ..."
                      onChange={handleChangeSales}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>NIK</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        const input = e.target.value;
                        const numericInput = input.replace(/\D/g, ""); // Hanya angka yang diizinkan
                        if (numericInput.length <= 16) {
                          setNIK(numericInput);
                        }
                      }}
                      value={NIK}
                      maxLength={16}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>NPWP</b>
                  </Form.Label>
                  <Col sm={6}>
                    <InputMask
                      className="form-control"
                      mask="99.999.999-9.999.9999"
                      maskPlaceholder="XX.XXX.XXX-X.XXX.XXXX"
                      onChange={(e) => setNPWP(e.target.value)}
                      value={NPWP}
                    ></InputMask>
                    {/* <InputMask mask="99/99/99" maskPlaceholder="-" value="12" /> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Customer Type <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={optionsPaymentType}
                      value={getValueStatus(customerType, optionsPaymentType)}
                      placeholder="Select ..."
                      onChange={handleChangeCustType}
                    />
                  </Col>
                </Form.Group>
                {customerType === "CREDIT" && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>Term Of Payment</b>
                    </Form.Label>
                    <Col sm={6}>
                      <Select
                        options={optionsTOP}
                        value={getValueStatus(TOP, optionsTOP)}
                        placeholder="Select ..."
                        onChange={handleChangeTop}
                      />
                    </Col>
                  </Form.Group>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>File NIK</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      ref={ref}
                      type="file"
                      label="Input File Name"
                      onChange={(e) => setFileNIK(e.target.files[0])}
                      custom
                      accept=".jpg,.png"
                    />
                  </Col>
                  <Col>
                    {fileNIK && (
                      <div
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1 my-1"
                        onClick={() => handlePreview(fileNIK)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-secondary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Design/Image.svg"
                            )}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>File NPWP</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      ref={ref}
                      type="file"
                      label="Input File Name"
                      onChange={(e) => setFileNPWP(e.target.files[0])}
                      custom
                      accept=".jpg,.png"
                    />
                  </Col>
                  <Col>
                    {fileNPWP && (
                      <div
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1 my-1"
                        onClick={() => handlePreview(fileNPWP)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-secondary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Design/Image.svg"
                            )}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                </Form.Group>

                {fields.map((field, idx) => {
                  return (
                    <div key={`${field}-${idx}`}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>File Lokasi {idx + 1}</b>
                        </Form.Label>
                        <Col sm={8}>
                          {field.files === null && (
                            <Form.Control
                              className="pt-3"
                              type="file"
                              defaultValue={field.files || null}
                              onChange={(e) => handleFileChangeToko(idx, e)}
                              accept=".jpg,.png"
                            />
                          )}
                          {field.files !== null && (
                            <div className="filename-container">
                              <div className="div-filename">
                                {field.files.name}
                              </div>

                              <div
                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                onClick={(e) =>
                                  handleDeleteFileToko(idx, e, field.type)
                                }
                              >
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/General/Trash.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          )}
                        </Col>
                        <Col sm={1}>
                          {fields.length - 1 === idx &&
                            fields.length < MAX_PHOTO_VISIT && (
                              <div
                                className="btn btn-icon btn-light btn-hover-danger btn-sm mr-5 mt-5"
                                onClick={() => handleAddFotoToko()}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Code/Plus.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            )}

                          {fields.length - 1 === idx &&
                            MAX_PHOTO_VISIT === "0" && (
                              <div
                                className="btn btn-icon btn-light btn-hover-danger btn-sm mr-5 mt-5"
                                onClick={() => handleAddFotoToko()}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/Code/Plus.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            )}
                        </Col>
                      </Form.Group>
                    </div>
                  );
                })}

                {id !== undefined && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}>
                      <b>File Attachment</b>
                    </Form.Label>
                    <Col sm={9}>
                      <React.Fragment>
                        {dataId?.customer_attachments?.map(
                          (attachment, idx) => (
                            <Form.Row
                              className="mt-3"
                              key={attachment.customer_attachment_id}
                            >
                              <Col sm={3}>
                                <Form.Control
                                  type="text"
                                  disabled
                                  value={attachment.file_type}
                                />
                              </Col>
                              <Col sm={6}>
                                <div
                                  className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3"
                                  onClick={() =>
                                    handlePreviewOld(attachment.file_path)
                                  }
                                >
                                  <span className="svg-icon svg-icon-md svg-icon-secondary">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/Design/Image.svg"
                                      )}
                                    />
                                  </span>
                                </div>
                                <div
                                  className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                  onClick={() =>
                                    handleDelete(attachment.file_type)
                                  }
                                >
                                  <span className="svg-icon svg-icon-md svg-icon-danger">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/General/Trash.svg"
                                      )}
                                    />
                                  </span>
                                </div>
                              </Col>
                            </Form.Row>
                          )
                        )}
                      </React.Fragment>
                    </Col>
                  </Form.Group>
                )}
              </Col>
            </Form.Group>
          </Form>{" "}
          <Tabs
            defaultActiveKey="Location"
            id="uncontrolled-tab-example"
            className="nav nav-tabs nav-tabs-line "
            activeKey={activeTab}
            onSelect={(e) => setActiveTab(e)}
          >
            <Tab eventKey="Location" title="Location">
              <div className="mt-5">
                <Form>
                  <Form.Group as={Row}>
                    <Col sm={6}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Provinsi</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            onChange={(e) => setProvinsi(e.target.value)}
                            value={provinsi}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Kabupaten / Kota</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            onChange={(e) => setKota(e.target.value)}
                            value={kota}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Kacamatan</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            onChange={(e) => setKecamatan(e.target.value)}
                            value={kecamatan}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Kelurahan</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            onChange={(e) => setKelurahan(e.target.value)}
                            value={kelurahan}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Alamat</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            onChange={(e) => setAlamat(e.target.value)}
                            value={alamat}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <div>
                        <GoogleMap
                          id="autocomplete-demo"
                          mapContainerStyle={mapContainerStyle}
                          zoom={16} // Gunakan zoom yang diperbarui
                          center={
                            id === undefined ? userPosition : clickedPosition
                          }
                          onClick={handleClick}
                          onLoad={(map) => {
                            mapRef.current = map;
                          }}
                        >
                          {/* {userPosition && <Marker position={userPosition} />} */}
                          {clickedPosition && (
                            <Marker position={clickedPosition} />
                          )}
                          <Autocomplete
                            onLoad={onLoad}
                            onPlaceChanged={onPlaceChanged}
                          >
                            <input
                              type="text"
                              placeholder="Enter a location"
                              style={{
                                boxSizing: `border-box`,
                                border: `1px solid transparent`,
                                width: `240px`,
                                height: `32px`,
                                padding: `0 12px`,
                                borderRadius: `3px`,
                                boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                fontSize: `14px`,
                                outline: `none`,
                                textOverflow: `ellipses`,
                                position: "absolute",
                                left: "50%",
                                marginLeft: "-120px",
                              }}
                            />
                          </Autocomplete>
                        </GoogleMap>
                      </div>
                    </Col>
                  </Form.Group>
                </Form>
              </div>
            </Tab>
            <Tab eventKey="Visit" title="Visit Configuration">
              <div className="mt-5">
                <Form>
                  <Form.Group as={Row}>
                    <Col sm={6}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Frequensi kunjungan</b>
                        </Form.Label>
                        <Col sm={6}>
                          <Select
                            options={optionsFreq}
                            value={getValueStatus(frequensi, optionsFreq)}
                            placeholder="Select ..."
                            onChange={handleChangeFrequensi}
                            isClearable={true}
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group as={Row}>
                        <Form.Label column sm={3}>
                          <b>Hari Kunjungan</b>
                        </Form.Label>
                        <Col sm={6}>
                          {kunjungan.map((item, index) => {
                            return (
                              <Form.Check
                                key={index}
                                label={item.label}
                                value={item.value}
                                name="group1"
                                type="checkbox"
                                inline
                                className="mr-8 mb-4"
                                checked={item.checked === true ? true : false}
                                onChange={(e) => {
                                  if (e.target.checked === true) {
                                    handleChecked(item.value);
                                  } else {
                                    handleRemoveChecked(item.value);
                                  }
                                }}
                              />
                            );
                          })}
                        </Col>
                      </Form.Group>
                    </Col>
                  </Form.Group>
                </Form>
              </div>
            </Tab>
            {id !== undefined && (
              <Tab eventKey="OrderHistory" title="Order History">
                <ToolkitProvider
                  keyField="no"
                  data={tableDataOrder}
                  columns={columnsOrder}
                  search
                >
                  {(props) => (
                    <div className="mt-5">
                      <Row>
                        <Col>
                          <Form.Group as={Row}>
                            <Form.Label column sm={3}>
                              <b>Order Date</b>
                            </Form.Label>
                            <Col sm={6}>
                              <InputDateRange
                                setEndDate={setEndOrder}
                                setStartDate={setStartOrder}
                                endDate={endOrder}
                                startDate={startOrder}
                                CallApi={fetchOrder}
                                paramsFilter={paramsFilterRange}
                                paramsStart={"start_order_date"}
                                paramsEnd={"end_order_date"}
                                hidden={true}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container ">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </Tab>
            )}
            {id !== undefined && (
              <Tab eventKey="VisitHistory" title="Visit History">
                <ToolkitProvider
                  keyField="no"
                  data={tableDataVisit}
                  columns={columnsVisit}
                  search
                >
                  {(props) => (
                    <div className="mt-5">
                      <Row>
                        <Col>
                          <Form.Group as={Row}>
                            <Form.Label column sm={3}>
                              <b>Visit Date</b>
                            </Form.Label>
                            <Col sm={6}>
                              <InputDateRange
                                setEndDate={setEndPlan}
                                setStartDate={setStartPlan}
                                endDate={endOrder}
                                startDate={startOrder}
                                CallApi={fetchVisit}
                                paramsFilter={paramsFilterRange}
                                paramsStart={"start_visit_plan_date"}
                                paramsEnd={"end_visit_plan_date"}
                                hidden={true}
                              />
                            </Col>
                          </Form.Group>
                        </Col>
                        <Col>
                          <div className="float-right">
                            <SearchBar
                              {...props.searchProps}
                              placeholder="Search .."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-container ">
                        <BootstrapTable
                          // wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center"
                          bootstrap4
                          bordered={true}
                          {...props.baseProps}
                        />
                      </div>
                    </div>
                  )}
                </ToolkitProvider>
              </Tab>
            )}
          </Tabs>
        </CardBody>
      </Card>
      <PreviewModal
        show={showPreview}
        handleClose={handleClosePreview}
        data={dataPreview}
      />
      <ViewerImageOld
        show={showPreviewOld}
        handleClose={handleClosePreview}
        data={dataPreviewOld}
      />

      <ModalDatalog
        show={showDatalog}
        setShow={setShowDatalog}
        id={id}
        setFetched={setFetched}
        fetched={fetched}
        showDetail={showDatalogDetail}
        setShowDetail={setShowDatalogDetail}
      />

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columns}
              hover
              striped
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
